/**
 * WhitelistBanner — the in-content "WHITELIST MODE" indicator shown above a
 * tab whose features are gated behind a console whitelist. Extracted from
 * DevToolsPanel during the decomposition; behavior-preserving.
 */
import React from 'react';
import { getWhitelist, type DevToolsTabId } from './DevTools.config';
import {
  whitelistBannerStyle,
  whitelistBannerRowStyle,
  whitelistBannerHintStyle,
} from './devToolsPanelStyles';

interface WhitelistBannerProps {
  tabId: DevToolsTabId;
}

export const WhitelistBanner: React.FC<WhitelistBannerProps> = ({ tabId }) => (
  <div style={whitelistBannerStyle}>
    <div style={whitelistBannerRowStyle}>
      <span>🧪</span>
      <span>WHITELIST MODE</span>
      <span style={{ opacity: 0.7 }}>|</span>
      <span>Showing: [{getWhitelist(tabId).join(', ') || 'none'}]</span>
    </div>
    <div style={whitelistBannerHintStyle}>
      Console: whitelistFeature(&quot;{tabId}&quot;, &quot;featureName&quot;)
    </div>
  </div>
);
